
















import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import DropdownSelect from '../../atoms/DropdownSelect.vue'
import { SelectItem } from '../../atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class DateDropdownSelect extends Vue {
  /**
   * disabled項目が（初期表示時に）選択されている可能性をnullとして表現している。
   */
  @Prop({ default: null })
  value: number | null

  @Prop({
    // default: 全ての要素を有効とする
    default: () => (() => false),
  })
  disableFilter: (date: number) => boolean

  get dateList(): SelectItem[] {
    return [
      {
        text: '',
        value: '',
        selected: this.value === null,
        disabled: true,
      },
      // tslint:disable-next-line:no-magic-numbers
      ..._.range(1, 32).map((date: number) => ({
        value: `${date}`,
        text: `${date}`,
        selected: date === this.value,
        disabled: this.disableFilter ? this.disableFilter(date) : false,
      })),
    ]
  }

  onInput(value) {
    this.$emit('input', value)
  }
}
